<div class="wrapper" [ngClass]="{'show-csat': showCsat}">
  <div class="content">
    <div class="birdy">
      <img src="/assets/images/birds_black.png" alt="birdy">
    </div>
    <div class="text-content">
      <div class="title">
        <div class="loaded">
          <span class="material-icons">done</span>
        </div>
        <div class="amount">
          <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{order?.total_amount_charged}}
        </div>
      </div>
      <div class="below-text">
        <div class="header">
          <div>We love</div>
          <div>your kindness!</div>
        </div>
        <div class="header-text">
          Thank you for your contribution of
          <div><app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{order?.donated_amount}} <span *ngIf="order?.tip_amount">and tip of <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{order?.tip_amount}}!</span></div>
        </div>
      </div>
    </div>
    <div class="img-hands">
      <div class="hands">
        <div class="hand1"><img class="hand1" loading="lazy" [attr.data-src]="'/assets/images/hand-1.png'" alt="hand1"></div>
        <div class="hand2"><img class="hand2" loading="lazy" [attr.data-src]="'/assets/images/hand-2.png'" alt="hand2"></div>
        <div class="hand3"><img class="hand3" loading="lazy" [attr.data-src]="'/assets/images/hand-3.png'" alt="hand3"></div>
        <div class="hand4"><img class="hand4" loading="lazy" [attr.data-src]="'/assets/images/hand-4.png'" alt="hand4"></div>
      </div>
    </div>
    <div *ngIf="showCsat && vwo.csat_typ_AB()" class="csat">
      <app-component-loader [load]="true" selector="app-csat" />
    </div>
  </div>
</div>
